/**
 * @fileoverview Outreach Vuex getters for computed state values.
 * @module store/modules/outreach/getters
 */

import { RootState } from "@/store/types";
import { GetterTree } from "vuex";
import { OutreachState } from "./types";

const getters: GetterTree<OutreachState, RootState> = {
  /**
   * Gets the contacts array with data and count.
   *
   * @param {OutreachState} state - Current module state
   * @returns {Object} Contacts object with data array and count
   */
  contactsArray(state) {
    return state.contacts;
  },
  /**
   * Gets the contacts tags.
   *
   * @param {OutreachState} state - Current module state
   * @returns {Object} Tags object with data array
   */
  contactsTags(state) {
    return state.tags;
  },
  /**
   * Gets the contacts stages.
   *
   * @param {OutreachState} state - Current module state
   * @returns {Object} Stages object with data array
   */
  contactsStages(state) {
    return state.stages;
  },
  /**
   * Gets the contact filter board configuration.
   *
   * @param {OutreachState} state - Current module state
   * @returns {Array} Filter board configuration array
   */
  contactFilterBoard(state) {
    return state.filterBoard;
  },
  /**
   * Gets the contact attributes definitions.
   *
   * @param {OutreachState} state - Current module state
   * @returns {Array} Array of contact attribute definitions
   */
  contactAttributes(state) {
    return state.contactAttributes;
  },
};

export default getters;
